import React, { useState, useEffect } from "react";
import ButtonLoader from "../loaders/ButtonLoader";

type ButtonType = {
  text: string;
  onClick?: () => Promise<void> | void;
  isActive: boolean;
  ref?: React.Ref<HTMLButtonElement>;
  isButtonLoading?: boolean;
  buttonColor?: string;
  borderColor?: string;
  isHollow?: boolean;
  className?: string;
  prefixText?: React.ReactNode;
};

const CustomButton = React.forwardRef<HTMLButtonElement, ButtonType>(
  (props, ref) => {
    const [isButtonDisabled, setIsButtonDisabled] = useState(false);
    const handleVerification = async () => {
      if (props.onClick) {
        setIsButtonDisabled(true);
        try {
          await props.onClick();
        } catch (error) {
          console.error("Error occurred:", error);
        } finally {
          setIsButtonDisabled(false);
        }
      }
    };

    const activeButtonColor = props.buttonColor || "bg-bg-button-primary";
    const activeBorderColor = props.borderColor || "border-bg-button-primary";

    useEffect(() => {
      if (props.isButtonLoading) {
        setIsButtonDisabled(true);
      } else {
        setIsButtonDisabled(false);
      }
    }, [props.isButtonLoading]);

    return (
      <div>
        {props.isActive ? (
          props.isButtonLoading ? (
            <button
              ref={ref}
              className={`${activeButtonColor} border ${activeBorderColor} ${props.className} w-full font-semibold py-3 px-4 flex items-center justify-center disabled rounded-lg`}
              onClick={handleVerification}
              disabled={isButtonDisabled}
            >
              <ButtonLoader />
            </button>
          ) : (
            <button
              ref={ref}
              className={`flex-1 text-[14px]  font-semibold border ${
                props.className ? props.className : "w-full"
              }
              } ${
                props.className
              } border ${activeBorderColor} py-3 px-4 rounded-lg ${
                props.isHollow
                  ? "text-bg-button-primary bg-[#ffffff]"
                  : `${activeButtonColor} text-text-base"`
              }`}
              onClick={handleVerification}
              disabled={isButtonDisabled}
            >
              <div className="flex flex-row items-center justify-center">
                {props.prefixText && (
                  <div className="mr-2">{props.prefixText}</div>
                )}
                <p>{props.text}</p>
              </div>
            </button>
          )
        ) : (
          <button
            ref={ref}
            className={`bg-bg-disabled ${
              props.className ? props.className : "w-full"
            } text-[14px] font-semibold py-3 px-4 rounded-lg text-text-disabled`}
            disabled
          >
            <div className="flex flex-row items-center justify-center">
              {props.prefixText && (
                <div className="mr-2">{props.prefixText}</div>
              )}
              <p>{props.text}</p>
            </div>
          </button>
        )}
      </div>
    );
  }
);

export default CustomButton;
